
























































































import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";
import { State, Action, Getter } from "vuex-class";
import { FinancialReportData } from "@/entities";
import { AppConstants as _app } from "@/shared/app.constants";
import { DetailExpense } from '@/entities/grants';
import TableComponent from './Components/DetailedExpenseTable.vue';
import ImportLog from '@/components/common/ValidationMessage/ImportLog.vue';
import HeaderInfo from '../../ExpansionPanel/FinExpansionPanel.vue';
import NavButtons from '@/components/common/Buttons/NavButtons.vue';

const namespace: string = "financialReport";
@Component({
  components: {
    TableComponent,
    HeaderInfo,
    NavButtons,
    ImportLog
  }
})
export default class DetailExpensesComponent extends Vue {
  @State(namespace) financialReport!: FinancialReportData;
  @Getter('selectedReport', {namespace}) report: any;
  @Getter('grantInfo', {namespace}) grantInfo: any;
  @Prop() financialReportSections: any;
  @Prop() validations: any
  @Prop() model: any;
  @Prop() readonly: any;
  @Prop() schema: any;
  @Prop() formOptions: any;
  @Prop() isDirty: any;
  @Prop() workFlowItems: any;
  @Prop() preValidation: any;
  @Prop() entity: any;
  @Prop() currency: string;
  @Prop() enableButton: any;
  @Prop() isFinalReport: boolean;
  @Prop() validationImport: boolean;

  mounted() {}

  getFeedbackHeader(rowKey) {
    if (this.formOptions && this.formOptions.feedbacks) {
      return this.formOptions.feedbacks.find(x => x.RowKey === rowKey);
    } else {
        return null;
    }
  }

  get dataModel() {
    if (!this.model.detailedExpenses) {
      this.model.detailedExpenses = [];
    }
    return this.model.detailedExpenses;
  }

  get attachedDocs() {
    const docs = this.model.finReportDocuments || [];
    const filteredDocs = docs.filter(doc => doc.name && Object.keys(doc).length > 0);
    return filteredDocs.length ? filteredDocs : null;
  }

  get header() {
    if(this.schema && this.schema.properties && this.schema.properties.detailedExpenseHeaders) {
      return this.schema.properties.detailedExpenseHeaders.items
    }
  }

  get currencyList() {
    return this.financialReport.currencyList;
  }

  get budgetCategories() {
    return this.financialReport.categories;
  }

  get budget() {
    let obj: any = {};
    if (
      this.financialReport.grantData &&
      this.financialReport.grantData.applicationBudget
    ) {
      obj = this.financialReport.grantData.applicationBudget;
    }
    return obj;
  }

  aggregate(item: DetailExpense) {
    item.amountInEUR = (item.amountInOriginalCurrency || 0) * (item.exchangeRate || 0);     
    // this.updateStatement(item.budgetLine);   
  }

  /** update the statement */
  updateStatement(budgetLine: string) {
      // if(this.model.statementOfExpeditures){
      //     /***details  */
      //     var exp = this.model.statementOfExpeditures.find(x => x.activityCode == budgetLine);
          
      //     if(exp) {
      //       /** statement */
      //       let oldVal: number = exp.currentExpenditure;
      //       exp.currentExpenditure = this.dataModel.filter(x => x.budgetLine == budgetLine)
      //       .map(x => x.amountInEUR).reduce((a, b) => a + b || 0, 0);
      //       exp.totalExpenditure = exp.totalExpenditure + (exp.currentExpenditure - (oldVal || 0 ));
      //       exp.availableAmount = exp.amountBudgeted - exp.totalExpenditure;
      //     }

      //     /** consolidation */
      //     this.model.consolidation.expenditureSummary = this.dataModel.filter(x => !x.isBankingCharges).map(x => x.amountInEUR).reduce((a, b) => a + b || 0, 0);
      //     this.model.consolidation.bankCharges = this.dataModel.filter(x => x.isBankingCharges).map(x => x.amountInEUR).reduce((a, b) => a + b || 0, 0);
      //     this.model.consolidation.totalExpenditure = this.model.consolidation.expenditureSummary + this.model.consolidation.bankCharges
      //     this.model.consolidation.totalCredited = ( (this.model.consolidation.balanceAtBeginning || 0) + (this.model.consolidation.fundInflow || 0) + (this.model.consolidation.creditInterest || 0) );
      //     this.model.consolidation.balance = this.model.consolidation.totalCredited - (this.model.consolidation.totalExpenditure ?? 0);
      //     this.model.consolidation.replenishAmount = this.model.consolidation.balance - (this.model.consolidation.forecast ?? 0);
      // }
  }

  // resolve import formula errors
  resolve() {
    const self = this;
    let formulaErrors: Array<any> = this.validations.filter(x => x.validationType === 'formula');
    formulaErrors.forEach((x: any) => {
      if(self.dataModel[x.rowIndex]){ 
        self.aggregate(self.dataModel[x.rowIndex]);
      }
    })

    this.$emit('resolvedError', this.validations.filter(x => x.validationType !== 'formula') )
  }
}
